import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { CustomerInfoLoadIfNormalUserGuard } from 'app/core/guards/customer-info-load-if-normal-user.guard';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { logger } from 'app/core/util/logger';
import { Observable, of } from 'rxjs';
import * as fromRoot from '..';
import { EmailActorsLoadAction } from './email-actors.actions';
import { first, map, switchMap } from 'rxjs/operators';

/**
 * Guard to async load the email actors before following a route
 */
@Injectable({ providedIn: 'root' })
export class GetEmailActorsGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    logger.debug(`In GetEmailActorsGuard`);
    return this.store.pipe(
      first(),
      map(state => state.session.authorization.data.ORDER.CREATE),
      switchMap(canCreateOrder => {
        return this.store
          .select(state => state.session)
          .pipe(
            first(),
            map(session => session.selectedCustomer.data),
            switchMap(selectedCustomer => {
              if (selectedCustomer?.id) {
                this.store.dispatch(new EmailActorsLoadAction(selectedCustomer?.id));
              }
              return of(true);
            })
          );
      })
    );
  }

  getDependencies(): any {
    return [CustomerInfoLoadIfNormalUserGuard];
  }

  getDependencyRouteData(): any {
  }
}
